import { useLoadingMessages } from '@/hooks'

export function Thoughts({
  loadingTransKeys,
  isThinking,
}: {
  isThinking: boolean
  loadingTransKeys: string[]
}) {
  const loadingMessage = useLoadingMessages(loadingTransKeys, isThinking)
  return loadingMessage
}
